<template>


  <div class="row" v-bind:class="{'is-loading':loading}">
    <div class="col-sm-8">

      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-lg">

              <h3>{{ $t('payments.new_payment') }}</h3>
            </div>
            <div class="col-lg-auto">
              <button type="button"
                      class="btn btn-outline-primary"
                      v-on:click="autoFill2()">
                {{ $t('payments.autofill') }}
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="form-group row"><label
              class="col-sm-12 col-form-label">{{ $t('payments.user') }}</label>
            <div class="col-sm-auto">
              <a :href="`/admin/user/${user.id}/edit`"
                 class="btn btn-outline-secondary">{{ user.name }}</a>
              <br>
              <span v-if="user.comments">
							{{ $t('payments.comment') }} {{ user.comments }}
							</span>
            </div>
            <div class="col-sm">
              <table class="table table-hover table-sm">
                <thead>
                <tr>
                  <th>{{ $t('withdrawal.withdrawals') }}</th>
                  <template v-if="user.contribution">
                    <th>{{ $t('contribute.contributions') }}</th>
                    <th>{{ $t('payments.base_for_zus') }}</th>
                    <th>{{ $t('payments.cost_contract_of_mandate') }}</th>
                    <th>{{ $t('payments.k_obs_uz') }}</th>
                    <th>{{ $t('payments.we_send') }}</th>
                  </template>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <span v-if="user.withdrawals === 'daily'">{{ $t('payments.daily') }}</span>
                    <span
                        v-if="user.withdrawals === 'weekly'">{{ $t('payments.weekly') }}</span>
                    <span v-if="user.withdrawals === 'per-request'">{{ $t('payments.per_request') }}</span>
                  </td>
                  <template v-if="user.contribution">
                    <td>{{ user.contribution.name }}</td>
                    <td>{{ user.base_for_zus }}</td>
                    <td>{{ user.zus_cost }}</td>
                    <td>{{ user.zus_cost_z }}</td>
                    <td>{{ user.zus_send }}</td>
                  </template>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <input type="hidden"
                 name="user_id"
                 :value="`${user.id}`"/>
          <div class="form-group row">
            <div class="col-sm-12 col-form-label"><strong>{{ $t('payments.balances') }}</strong></div>
            <div class="col-sm">
              <table class="table table-hover table-sm">
                <thead>
                <tr>
                  <td></td>
                  <td>{{ $t('payments.balance', { currency: $getCurrencySymbol() }) }}</td>
                  <td>{{ $t('payments.cash', { currency: $getCurrencySymbol() }) }}</td>
                  <td>{{ $t('payments.turnover', { currency: $getCurrencySymbol() }) }}</td>
                  <td>{{ $t('payments.created_at') }}</td>
                  <td>{{ $t('payments.application') }}</td>
                  <td>{{ $t('payments.balance_company') }}</td>
                  <td>{{ $t('payments.provision') }}</td>
                  <td>{{ $t('payments.taxes') }}</td>
                  <td>{{ $t('payments.status') }}</td>
                  <td>{{ $t('payments.zus_taken') }}</td>
                  <td>{{ $t('payments.contributions') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="balance in balances"
                    v-on:click="toggleBalance(balance)">
                  <td>
                    <input type="checkbox"
                           v-model="selectedBalances"
                           :value="balance"/>
                    {{ balance.id }}
                  </td>
                  <td>{{ balance.online }}</td>
                  <td>{{ balance.collected_cash }}</td>
                  <td>{{ balance.total }}</td>
                  <td>{{ formatDate(balance.created_at) }}</td>
                  <td>{{ balance.application.name }}</td>
                  <td>{{ balance.settlement_company_name }}</td>
                  <td>{{ $filters.toCurrency(+balance.provision) }}</td>
                  <td>
                    <template v-if="balance.imported && balance.imported.length>0">
                      <strong>
                                                <span
                                                    v-for="vat in balance.imported">[{{ vat.vat }}% {{
                                                    $filters.toCurrency(+vat.value)
                                                  }}]</span>
                      </strong>
                    </template>
                    <template v-else>
                      <input type="radio"
                             :id="`vat0-${balance.id}`"
                             :name="`vat-${balance.id}`"
                             v-model="balance.vat"
                             value="0"
                             class="part-vat"
                             v-on:change="calculatePayment()"
                             checked/>
                      <label :for="`vat0-${balance.id}`"
                             class="mx-2 my-0">0%</label>
                      <input type="radio"
                             :id="`vat8-${balance.id}`"
                             v-on:change="calculatePayment()"
                             :name="`vat-${balance.id}`"
                             v-model="balance.vat"
                             value="8.1"
                             class="part-vat"/>
                      <label :for="`vat8-${balance.id}`"
                             class="mx-2 my-0">8%</label>
                      <input type="radio"
                             :id="`vat23-${balance.id}`"
                             v-on:change="calculatePayment()"
                             :name="`vat-${balance.id}`"
                             v-model="balance.vat"
                             value="18.7"
                             class="part-vat"/>
                      <label :for="`vat23-${balance.id}`"
                             class="mx-2 my-0">23%</label>
                    </template>
                  </td>
                  <td>
                    <span v-if="balance.status">{{ $t('payments.active') }}</span>
                    <span v-if="!balance.status">{{ $t('payments.inactive') }}</span>
                  </td>
                  <td>
                    <span v-if="balance.zus_taken">{{ $t('payments.yes') }}</span>
                    <span v-if="!balance.zus_taken">{{ $t('payments.no') }}</span>
                  </td>
                  <td>
                    <div v-for="(item, itemIndex) in balance.contribution_items"
                         :key="itemIndex">
                      {{ item.name }}<span v-if="item.percentage"> ({{ item.percentage }}%)</span>
                      {{ $filters.toCurrency(+item.amount) }}
                      <small v-if="item.category === 'employer'">({{ $t('payments.employer_contributions') }})</small>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="form-group row">

            <div class="col-12">
              <input type="hidden" name="additional_fields_touched" value="1">
              <additional-fields-component :additional-fields="additionalFields"
                                           :title="$t('payments.additional_fields')"
                                           :key="componentKey"
                                           :show-repeat="false"
                                           @fields-changed="additionalFieldsChanged"
                                           :fields="paymentAdditionalFields"></additional-fields-component>
              <div v-if="isSplit"
                   class="alert alert-info py-2 small mb-0">
                {{ $t('payments.split_manual_hint') }}
              </div>
            </div>


          </div>
          <!-- Pola klasycznego rozliczenia (jeden obieg legacy). Przy podziale na obiegi serwer ich
               nie używa — ukryte, ale zostają w formularzu (walidacja wymaganych pól). -->
          <div v-show="!isSplit">
          <div class="row"
               v-if="user.referral_ask>0">
            <div class="col-lg-12">
              {{ $t('payments.referral_ask') }}
              <strong>{{ $filters.toCurrency(+user.referral_ask) }}</strong>
              <label>
                <input type="checkbox"
                       v-on:change="referralCbChanged()"
                       v-model="referral_cb"
                       :value="+user.referral_ask"
                       name="referral_ask"/>
                {{ $t('payments.accept') }}
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2">
              {{ $t('payments.possible_return') }}
            </div>
            <div class="col-lg">
              VAT: <strong>{{ $filters.toCurrency(invoices_vat_return) }}</strong>
            </div>
            <div class="col-lg">
              Koszty: <strong>{{ $filters.toCurrency(invoices_cost_return) }}</strong>
            </div>
            <div class="col-lg-auto">
              <button type="button"
                      class="btn btn-outline-primary"
                      v-on:click="useReturns()">
                {{ $t('payments.use_in_payment') }}
              </button>
            </div>
          </div>

          <div class="form-group row">

            <label for="vat2"
                   class="col-sm-2 col-form-label">
              {{ $t('payments.enter_vat_return_50') }}
            </label>
            <div class="col-sm-10">
              <input type="text"
                     name="vat2"
                     v-model="vat2"
                     v-on:change="calculatePayment()"
                     id="vat2"
                     class="form-control"
                     :required="!isSplit"
                     placeholder="{{$t('payments.warning_reduce_tax')}}">

            </div>

          </div>

          <div class="form-group row align-items-center">
            <label for="provision"
                   class="col-sm-2 col-form-label">{{ $t('payments.provision_label') }}</label>
            <div class="col-sm">
              <input name="provisionManual"
                     type="number"
                     v-on:change="calculatePayment()"
                     v-model="provision"
                     id="provision"
                     class="form-control">
              <input name="provision"
                     type="hidden"
                     v-model="provisionTotal">
            </div>
            <div class="col-sm-auto">
              <div class="btn-group">
                <button class="btn btn-outline-primary"
                        type="button"
                        v-on:click="setProvision(0)">{{ $filters.toCurrency(0) }}
                </button>
                <button class="btn btn-outline-primary"
                        type="button"
                        v-on:click="setProvision(20)">
                  {{ $filters.toCurrency(20) }}
                </button>
                <button class="btn btn-outline-primary"
                        type="button"
                        v-on:click="setProvision(30)">
                  {{ $filters.toCurrency(30) }}
                </button>
                <button class="btn btn-outline-primary"
                        type="button"
                        v-on:click="setProvision(50)">
                  {{ $filters.toCurrency(50) }}
                </button>
              </div>
            </div>
            <div class="col-sm-2">
              {{ $t('payments.from_balances') }} <strong>{{ $filters.toCurrency(provisionFromBalances) }}</strong>
            </div>
          </div>
          <div class="form-group row">
            <label for="elixir"
                   class="col-sm-2 col-form-label">{{ $t('payments.transfer') }}</label>
            <div class="col-sm-10">
              <select id="elixir"
                      name="elixir"
                      required
                      v-on:change="calculatePayment()"
                      v-model="elixir"
                      class="form-control w-100">
                <option value="0"
                        selected="selected">{{ $t('payments.transfer_standard') }}
                </option>
                <option value="1">{{ $t('payments.transfer_elixir') }}</option>
              </select></div>
          </div>

          <div class="form-group row">
            <label for="firma"
                   class="col-sm-2 col-form-label">{{ $t('payments.company') }}</label>
            <div class="col-sm-10">
              <select id="firma"
                      name="firma"
                      required
                      v-on:change="calculatePayment()"
                      v-model="firma"
                      class="form-control w-100">
                <option value="0"
                        selected="selected">{{ $t('payments.no') }}
                </option>
                <option value="1">{{ $t('payments.yes') }}</option>
              </select>
            </div>
          </div>

          <!--                    <div class="form-group row d-none">-->
          <!--                        <label for="cost_uz_dochodowy"-->
          <!--                               class="col-sm-2 col-form-label">Koszt umowa zlecenie:</label>-->
          <!--                        <div class="col-sm-10">-->
          <input name="cost_uz_dochodowy"
                 type="hidden"
                 v-on:change="calculatePayment()"
                 v-model="cost_uz_dochodowy"
                 id="cost_uz_dochodowy"
                 class="form-control">
          <!--                </div>-->
          <!--                    </div>-->

          <template v-if="firma===1">
            <div class="form-group row">
              <label for="wyplata_b2b"
                     class="col-sm-2 col-form-label">{{ $t('payments.b2b') }}</label>
              <div class="col-sm-10">
                <input name="wyplata_b2b"
                       v-model="kwota_z_wyplat"
                       type="number"
                       step="0.01"
                       readonly
                       id="wyplata_b2b"
                       class="form-control"></div>
            </div>
          </template>
          <template v-else>
            <div class="form-group row align-items-center">
              <label for="wyplata_umowa_zlecenie"
                     class="col-sm-2 col-form-label">{{ $t('payments.contract_of_mandate') }}</label>
              <div class="col-sm">
                <input name="wyplata_umowa_zlecenie"
                       v-model="wyplata_umowa_zlecenie"
                       type="number"
                       step="0.01"
                       v-on:change="calculatePayment()"
                       id="wyplata_umowa_zlecenie"
                       class="form-control">
              </div>
              <div class="col-sm-auto"
                   v-if="user.contribution">
                <div class="btn-group">
                  <button class="btn btn-outline-primary"
                          type="button"
                          v-on:click="calculateZus()">
                    {{ $t('payments.zus_costs') }}
                  </button>
                </div>
              </div>
              <div class="col-sm-auto">
                <label>
                  <input type="checkbox"
                         v-model="zusIncluded"
                         name="zus-included"/>
                  {{ $t('payments.zus_included') }}
                </label>
              </div>
              <div class="col-sm-auto">
                <small>{{ $t('payments.last_taken') }}</small><br>
                {{ user.contribution_used_at ? user.contribution_used_at : $t('payments.non_taken') }}
              </div>
            </div>
            <div class="form-group row">
              <label for="wyplata_umowa_wynajmu"
                     class="col-sm-2 col-form-label">{{ $t('payments.lease_agreement') }}</label>
              <div class="col-sm-10">
                <input name="wyplata_umowa_wynajmu"
                       v-model="wyplata_umowa_wynajmu"
                       type="number"
                       step="0.01"
                       readonly
                       id="wyplata_umowa_wynajmu"
                       class="form-control"></div>
            </div>
            <div class="form-group row">
              <label for="wyplata_zwrot_kosztow"
                     class="col-sm-2 col-form-label">{{ $t('payments.reimbursement') }}</label>
              <div class="col-sm-10">
                <input name="wyplata_zwrot_kosztow"
                       type="number"
                       step="0.01"
                       v-on:change="calculatePayment()"
                       v-model="wyplata_zwrot_kosztow"
                       id="wyplata_zwrot_kosztow"
                       class="form-control"></div>
            </div>
            <div class="form-group row">
              <label for="wyplata_zwrot_kosztow"
                     class="col-sm-2 col-form-label">{{ $t('payments.service_agreement') }}</label>
              <div class="col-sm-10">
                <input name="wyplata_umowa_serwisowa"
                       type="number"
                       step="0.01"
                       v-on:change="calculatePayment()"
                       v-model="wyplata_umowa_serwisowa"
                       id="wyplata_umowa_serwisowa"
                       class="form-control"></div>
            </div>
          </template>
          </div>

        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="card sticky-top">
        <div class="card-header">
          <h3>{{ $t('payments.calculations') }}</h3>
        </div>
        <div class="card-body">

          <table v-if="isSplit">
            <tbody>
            <tr>
              <th>{{ $t('payments.cash') }}</th>
              <td class="text-right"><strong>{{ $filters.toCurrency(+(summary.total_cash ?? 0)) }}</strong></td>
            </tr>
            </tbody>
            <tfoot>
            <tr class="alert alert-info">
              <th class="p-2">{{ $t('payments.summary_total_payout') }}</th>
              <td class="text-right p-2"><strong>{{ $filters.toCurrency(+(summary.total_payment ?? 0)) }}</strong></td>
            </tr>
            </tfoot>
          </table>
          <table v-show="!isSplit">
            <tbody>
            <tr>
              <th>{{ $t('payments.gross_sum') }}</th>
              <td class="text-right"><strong>{{ $filters.toCurrency(calculated.brutto) }}</strong></td>
            </tr>
            <tr>
              <th>{{ $t('payments.online_sum') }}</th>
              <td class="text-right"><strong>{{ $filters.toCurrency(calculated.onlinePayment) }}</strong>
              </td>
            </tr>
            <tr>
              <th>{{ $t('payments.vat_due') }}</th>
              <td class="text-right"><strong>{{ $filters.toCurrency(calculated.totalVat) }}</strong></td>
            </tr>
            <tr>
              <th v-if="!firma">{{ $t('payments.lease_agreement') }}</th>
              <th v-if="firma">{{ $t('payments.b2b') }}</th>
              <td class="text-right"><strong>{{ $filters.toCurrency(+kwota_z_wyplat) }}</strong></td>
            </tr>
            <tr>
              <th>{{ $t('payments.service_agreement') }}</th>
              <td class="text-right"><strong>{{ $filters.toCurrency(+wyplata_umowa_serwisowa) }}</strong></td>
            </tr>
            <tr>
              <th>{{ $t('payments.cash') }}</th>
              <td class="text-right"><strong>{{ $filters.toCurrency(calculated.cash) }}</strong></td>
            </tr>
            <tr>
              <th>{{ $t('payments.bonus_payout') }}</th>
              <td class="text-right"><strong>{{
                  $filters.toCurrency(referral_cb ? +user.referral_ask : 0)
                }}</strong></td>
            </tr>
            </tbody>
            <tfoot>
            <tr class="alert alert-info">
              <th class="p-2">
                {{ $t('payments.payout') }}
              </th>
              <td class="text-right p-2"><strong>{{ $filters.toCurrency(total_payment) }}</strong></td>
            </tr>
            </tfoot>
          </table>

          <div class="alert alert-danger mt-2"
               v-if="!isSplit && total_payment<50">{{ $t('payments.low_payout') }}
          </div>
          <div class="alert alert-danger mt-2"
               v-if="!isSplit && total_payment<wyplata_umowa_zlecenie">{{ $t('payments.too_low_for_contract') }}
          </div>

          <input type="hidden"
                 v-model="calculated.cash"
                 name="cash"/>
          <input type="hidden"
                 v-model="calculated.brutto"
                 name="brutto"/>
          <input type="hidden"
                 v-model="calculated.onlinePayment"
                 name="amount"/>
          <input type="hidden"
                 v-model="calculated.totalVat"
                 name="vat"/>
          <input type="hidden"
                 v-model="kwota_z_wyplat"
                 name="wyplata_kwota_z_wyplat_value"/>
          <input type="hidden"
                 v-model="taxiB2bAmount"
                 name="wyplata_kwota_taxi"/>
          <input type="hidden"
                 v-model="courierB2bAmount"
                 name="wyplata_kwota_courier"/>
          <input type="hidden"
                 v-model="wyplata_umowa_serwisowa"
                 name="service"/>
          <input type="hidden"
                 v-model="zwrot_vat"
                 name="zwrot_vat"/>
          <input type="hidden"
                 v-model="total_payment"
                 name="saldo"/>
          <input name="provisionFromBalances"
                 type="hidden"
                 v-model="provisionFromBalances">
          <input name="taxiProvision"
                 type="hidden"
                 v-model="taxiProvision">
          <input name="courierProvision"
                 type="hidden"
                 v-model="courierProvision">
          <input type="hidden"
                 :value="transformBalances()"
                 name="selected_balances"/>

        </div>
      </div>
    </div>
    <div class="col-12"
         v-if="obiegi.length > 0">
      <div class="card mt-3">
        <div class="card-header">
          <h3>{{ $t('payments.settlement_preview') }}</h3>
        </div>
        <div class="card-body">
          <div v-for="(obieg, idx) in obiegi"
               :key="`obieg-${idx}`"
               class="card mb-3">
            <div class="card-header d-flex justify-content-between align-items-center">
              <strong>
                <span v-if="obieg.type === 'legacy'">{{ $t('payments.legacy_settlement') }}</span>
                <span v-else>{{ obieg.application_name }}</span>
                <small v-if="obieg.internal_company_name"
                       class="text-muted ml-2">({{ obieg.internal_company_name }})</small>
              </strong>
              <span class="badge"
                    :class="statusBadgeClass(obieg.status)">
                {{ $t('payments.obieg_status.' + obieg.status) }}
              </span>
            </div>
            <div class="card-body">
              <div v-if="obieg.status === 'below_minimum'"
                   class="alert alert-warning py-1 px-2 mb-3">
                {{ $t('payments.obieg_below_minimum', { minimum: $filters.toCurrency(+obieg.minimum_payout) }) }}
              </div>
              <div v-else-if="obieg.status === 'zero_unconfirmed'"
                   class="alert alert-warning py-1 px-2 mb-3">
                {{ $t('payments.zero_unconfirmed_hint') }}
              </div>
              <div v-else-if="obieg.status !== 'created'"
                   class="alert alert-warning py-1 px-2 mb-3">
                {{ $t('payments.obieg_not_created') }}
              </div>

              <template v-if="obieg.contribution_breakdown">
                <div v-if="obieg.contribution_breakdown.employee_deducted && obieg.contribution_breakdown.employee_deducted.length"
                     class="mb-2">
                  <strong>{{ $t('payments.contrib_employee_deducted') }}</strong>
                  <table class="table table-sm mb-1">
                    <tbody>
                    <tr v-for="(c, ci) in obieg.contribution_breakdown.employee_deducted"
                        :key="`ed-${idx}-${ci}`">
                      <td>{{ c.name }}</td>
                      <td class="text-right">{{ c.percentage }}%</td>
                      <td class="text-right">{{ $filters.toCurrency(+c.amount) }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="obieg.contribution_breakdown.employee_informational && obieg.contribution_breakdown.employee_informational.length"
                     class="mb-2">
                  <strong>{{ $t('payments.contrib_employee_informational') }}</strong>
                  <table class="table table-sm mb-1">
                    <tbody>
                    <tr v-for="(c, ci) in obieg.contribution_breakdown.employee_informational"
                        :key="`ei-${idx}-${ci}`">
                      <td>{{ c.name }}</td>
                      <td class="text-right">{{ c.percentage }}%</td>
                      <td class="text-right">{{ $filters.toCurrency(+c.amount) }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="obieg.contribution_breakdown.employer && obieg.contribution_breakdown.employer.length"
                     class="mb-2">
                  <strong>{{ $t('contribute.employer') }}</strong>
                  <table class="table table-sm mb-1">
                    <tbody>
                    <tr v-for="(c, ci) in obieg.contribution_breakdown.employer"
                        :key="`er-${idx}-${ci}`">
                      <td>{{ c.name }}</td>
                      <td class="text-right">{{ c.percentage }}%</td>
                      <td class="text-right">{{ $filters.toCurrency(+c.amount) }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>

              <div v-if="obieg.additional_fields && obieg.additional_fields.length"
                   class="mb-2">
                <strong>{{ $t('payments.additional_fields') }}</strong>
                <table class="table table-sm mb-1">
                  <tbody>
                  <tr v-for="(f, fi) in obieg.additional_fields"
                      :key="`af-${idx}-${fi}`">
                    <td>{{ f.name }}</td>
                    <td class="text-right">{{ $filters.toCurrency(+f.value) }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <table class="table table-sm mb-1">
                <tbody>
                <tr>
                  <th>{{ $t('payments.provision') }}</th>
                  <td class="text-right">{{ $filters.toCurrency(+(obieg.provisions?.total ?? 0)) }}</td>
                </tr>
                <tr>
                  <th>{{ $t('payments.gross_sum') }}</th>
                  <td class="text-right">{{ $filters.toCurrency(+(obieg.calculated?.brutto ?? 0)) }}</td>
                </tr>
                <tr>
                  <th>{{ $t('payments.online_sum') }}</th>
                  <td class="text-right">{{ $filters.toCurrency(+(obieg.calculated?.onlinePayment ?? 0)) }}</td>
                </tr>
                <tr>
                  <th>{{ $t('payments.vat_due') }}</th>
                  <td class="text-right">{{ $filters.toCurrency(+(obieg.calculated?.totalVat ?? 0)) }}</td>
                </tr>
                <tr>
                  <th>{{ $t('payments.cash') }}</th>
                  <td class="text-right">{{ $filters.toCurrency(+(obieg.calculated?.cash ?? 0)) }}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr class="alert alert-info">
                  <th class="p-2">{{ $t('payments.payout') }}</th>
                  <td class="text-right p-2">
                    <strong>{{ $filters.toCurrency(+(obieg.total_payment ?? 0)) }}</strong>
                  </td>
                </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div class="alert alert-success mb-0">
            <div class="d-flex justify-content-between">
              <strong>{{ $t('payments.summary_total_payout') }}</strong>
              <strong>{{ $filters.toCurrency(+(summary.total_payment ?? 0)) }}</strong>
            </div>
            <div class="d-flex justify-content-between">
              <span>{{ $t('payments.summary_total_cash') }}</span>
              <span>{{ $filters.toCurrency(+(summary.total_cash ?? 0)) }}</span>
            </div>
          </div>

          <div v-if="summary.below_minimum"
               class="alert alert-warning mt-2 mb-0">
            {{ $t('payments.summary_below_minimum') }}
          </div>
        </div>
      </div>
    </div>
    <!-- Zerowe rozliczenie (wypłata 0,00 zł, np. zajęcie komornicze) wymaga jawnego potwierdzenia.
         Natywny checkbox value="1": niezaznaczony nie wysyła pola, zaznaczony — "1"
         (PaymentRequest: nullable|boolean). Bez zaznaczenia przyciski są zablokowane. -->
    <div class="col-12"
         v-if="needsZeroConfirmation">
      <div class="alert alert-warning mb-3">
        <label class="mb-0">
          <input type="checkbox"
                 name="confirm_zero_payout"
                 value="1"
                 v-model="confirmZeroPayout"/>
          <strong class="ml-1">{{ $t('payments.confirm_zero_payout') }}</strong>
        </label>
      </div>
    </div>
    <div class="col-12">
      <input type="submit"
             :disabled="submitBlocked"
             class="btn btn-lg btn-success mb-3"
             name="submit"
             value="Prześlij"/>
      <input type="submit"
             :disabled="submitBlocked"
             name="submit"
             class="btn btn-lg btn-success mb-3"
             value="Prześlij i dodaj nowe"/>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import * as _ from 'lodash';
import AdditionalFields from "./AdditionalFields.vue";


export default {
  name: 'Payment',
  components: {AdditionalFields},
  data: function () {
    return {
      componentKey: 0,
      invoices_vat_return: 0,
      loading: false,
      invoices_cost_return: 0,
      paymentAdditionalFields: [],
      calculated: {
        brutto: 0,
        onlinePayment: 0,
        totalVat: 0,
        cash: 0
      },
      firma: 0,
      total_payment: 0,
      zwrot_vat: 0,
      kwota_z_wyplat: 0,
      selectedBalances: [],
      provision: 0,
      provisionTotal: 0,
      provisionFromBalances: 0,
      taxiProvision: 0,
      courierProvision: 0,
      taxiB2bAmount: 0,
      courierB2bAmount: 0,
      elixir: 0,
      vat2: 0,
      referral_ask: null,
      referral_cb: null,
      cost_uz_dochodowy: 0,
      wyplata_umowa_zlecenie: null,
      wyplata_umowa_wynajmu: null,
      wyplata_zwrot_kosztow: null,
      wyplata_umowa_serwisowa: 0,
      submitDisabled: true,
      confirmZeroPayout: false,
      zusIncluded: false,
      obiegi: [],
      summary: {
        total_payment: 0,
        total_cash: 0,
        below_minimum: false,
        zero_payout: false,
      },
    }
  },
  props: {
    balances: {
      type: Array,
      required: true
    },
    additionalFields: {
      type: Array,
      required: true
    },
    provisionSettings: {
      type: Object,
      required: true
    },
    provisionMultiplier: {
      type: Number
    },
    calculateUrl: {
      type: String,
      required: true
    },
    user: {
      type: Object
    }
  },
  watch: {
    paymentAdditionalFields: {
      handler: function () {
        this.calculatePayment();
      },
      deep: true
    },
    /**
     * Wybór typu pola w v-select nie emituje fieldsChanged, a od typu zależy, do którego obiegu
     * trafi pole — odświeżamy podgląd. Tylko przy zmianie typów, nie przy każdym znaku wartości
     * (wartość odświeża podgląd przez fieldsChanged po zatwierdzeniu pola).
     */
    fieldTypesSignature: function () {
      if (this.debouncedRefresh) {
        this.debouncedRefresh();
      }
    },
    selectedBalances: function () {
      this.calculatePayment();
    },
    /**
     * Potwierdzenie zerowego rozliczenia zmienia status obiegu po stronie serwera
     * (`zero_unconfirmed` → `below_minimum`/`created`), więc odświeżamy podgląd z flagą — ale
     * TYLKO w trybie split, gdzie kwoty liczy serwer. W trybie klasycznym (jeden obieg legacy)
     * odświeżenie nadpisałoby ręcznie skorygowane kwoty wypłat; tam flaga idzie dopiero
     * z formularzem, a serwer pilnuje jej na payloadzie.
     */
    confirmZeroPayout: function () {
      if (this.isSplit) {
        this.refreshPreview();
      }
    },
    /**
     * Potwierdzenie nie może „zostać" z poprzedniej konfiguracji sald/pól: gdy zerowe
     * rozliczenie przestaje być potrzebne, checkbox się odznacza.
     */
    needsZeroConfirmation: function (value) {
      if (!value) {
        this.confirmZeroPayout = false;
      }
    },
  },
  computed: {
    fieldTypesSignature() {
      return (this.paymentAdditionalFields || []).map((field) => field.additional_field?.id ?? null).join(',');
    },
    /**
     * Rozliczenie dzieli się na obiegi (salda live albo salda z kilku firm) — tak samo jak
     * decyduje PaymentController::store(). Kwoty liczy wtedy serwer, pola klasycznego
     * rozliczenia nie mają zastosowania.
     */
    isSplit() {
      const obiegi = this.obiegi || [];
      return obiegi.length > 1 || obiegi.some((obieg) => obieg.type === 'live');
    },
    /**
     * Suma wypłat, które w trybie klasycznym faktycznie trafią do payoutów (bez gotówki) — ta
     * sama liczba, której pilnuje guard w PaymentController::store() na payloadzie. Firma:
     * B2B (kwota_z_wyplat); inaczej edytowalne pola umów. Liczymy z pól formularza, a nie
     * z total_payment, żeby UI i serwer patrzyły na tę samą wartość.
     */
    legacyPayoutTotal() {
      if (+this.firma === 1) {
        return Math.round(100 * (+this.kwota_z_wyplat || 0)) / 100;
      }
      return Math.round(100 * (
          (+this.wyplata_umowa_wynajmu || 0)
          + (+this.wyplata_umowa_zlecenie || 0)
          + (+this.wyplata_zwrot_kosztow || 0)
          + (+this.wyplata_umowa_serwisowa || 0)
      )) / 100;
    },
    /**
     * Czy rozliczenie zawiera obieg z wypłatą 0,00 zł — wtedy admin musi zaznaczyć
     * „Potwierdzam zerowe rozliczenie". Tryb split: serwer mówi to wprost (summary.zero_payout,
     * status zero_unconfirmed albo obieg do utworzenia z wypłatą 0). Tryb klasyczny: suma pól
     * payloadu równa 0 przy zaznaczonych saldach — ale nie wtedy, gdy serwer blokuje obieg
     * z innego powodu (niedobór, ZUS): niedobór nie jest zerowym rozliczeniem i nie da się go
     * potwierdzić checkboxem.
     */
    needsZeroConfirmation() {
      if (this.selectedBalances.length === 0 || this.obiegi.length === 0) {
        return false;
      }
      if (this.isSplit) {
        return !!this.summary.zero_payout
            || this.obiegi.some((obieg) => obieg.status === 'zero_unconfirmed'
                || (['created', 'below_minimum'].includes(obieg.status) && +obieg.total_payment === 0));
      }
      return this.legacyPayoutTotal === 0
          && !['too_small', 'too_small_additional', 'empty'].includes(this.obiegi[0].status);
    },
    /**
     * Tryb klasyczny: wypłaty 0,00 przy obiegu zablokowanym przez serwer (niedobór — `too_small`,
     * `too_small_additional`) nie przejdą nawet z potwierdzeniem (wypłata ujemna blokuje zawsze),
     * więc nie puszczamy formularza — admin zobaczyłby tylko błąd po submicie.
     */
    legacyNegativeBlocked() {
      if (this.isSplit || this.obiegi.length === 0) {
        return false;
      }
      return this.legacyPayoutTotal === 0
          && ['too_small', 'too_small_additional'].includes(this.obiegi[0].status);
    },
    submitBlocked() {
      return this.submitDisabled
          || this.legacyNegativeBlocked
          || (this.needsZeroConfirmation && !this.confirmZeroPayout);
    },
  },
  mounted() {
    document.addEventListener('onFormSubmit', this.handleFormSubmit);
    // Podgląd obiegów musi nadążać za zaznaczeniem sald — inaczej suma na dole
    // zostaje zamrożona na stanie z autouzupełnienia.
    this.debouncedRefresh = _.debounce(this.refreshPreview, 300);
  },
  beforeUnmount() {
    document.removeEventListener('onFormSubmit', this.handleFormSubmit);
  },
  methods: {
    handleFormSubmit() {
      // Perform the necessary actions here
      this.blockSubmit();
    },
    sortArrays(arrays) {
      return _.orderBy(arrays, 'created_at', 'desc');
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    additionalFieldsChanged(fields) {
      this.paymentAdditionalFields = fields;
      this.calculatePayment();
      // Podgląd obiegów musi pokazać skutek korekty, a nie stan z serwera.
      this.debouncedRefresh();
    },
    transformBalances() {
      console.log(this.selectedBalances);
      if (!this.selectedBalances) {
        return '';
      }
      return this.selectedBalances.map(function (item) {
        console.log(item);
        return item.id;
      }).join(",");
    },
    blockSubmit() {
      this.submitDisabled = true;
    },
    setProvision(value) {
      this.provision = value;
      this.calculatePayment();
    },
    useReturns() {
      this.vat2 = (this.invoices_vat_return < this.calculated.totalVat ? this.invoices_vat_return : this.calculated.totalVat);
      this.calculatePayment();
      const rules = this.user.driver_class?.settlement_rules;
      const costReturnApplicable = rules ? !!rules.cost_return_applicable : !!this.user.firm_private;
      if (!costReturnApplicable) {
        this.wyplata_zwrot_kosztow = 0;
        return;
      }
      const vatFullReturn = rules ? (rules.vat_return_mode === 'full') : !!this.user.firm_vat;
      if (vatFullReturn) {
        this.vat2 = this.calculated.totalVat;
        this.calculatePayment();
        return;
      }
      this.wyplata_zwrot_kosztow = Math.min(this.wyplata_umowa_wynajmu, this.invoices_cost_return);
      this.calculatePayment();
    },
    getZusTotalCosts() {
      const rules = this.user.driver_class?.settlement_rules;
      const zusApplicable = rules ? !!rules.zus_applicable : (!this.user.only_rent && !this.user.firm_student);
      if (!zusApplicable) {
        return 0;
      }
      return +this.user.zus_cost_z + (+this.user.zus_cost);
    },
    calculateZus() {
      const rules = this.user.driver_class?.settlement_rules;
      const zusApplicable = rules ? !!rules.zus_applicable : !this.user.only_rent;
      if (!zusApplicable) {
        return;
      }
      if (this.user && this.user.contribution && this.user.zus_cost_z) {
        this.wyplata_umowa_zlecenie += +this.user.zus_send;
        this.paymentAdditionalFields.push({
          name: `Koszt umowa zlecenie`,
          value: -this.user.zus_cost
        });
        this.paymentAdditionalFields.push({name: `K.OBS.UZ`, value: -this.user.zus_cost_z});
        this.zusIncluded = true;
      }

      this.calculatePayment();
    },
    init() {
      this.invoices_vat_return = +this.user.invoices_vat_balance;// Math.round(100 * ((+this.user.invoices_vat_return) - (+this.user.used_invoice_return))) / 100;
      this.invoices_cost_return = +this.user.invoices_cost_balance;// Math.round(100 * ((+this.user.invoices_cost_return) - (+this.user.used_cost_return))) / 100;
      _.forEach(this.user.additional_fields, (item) => {
        item.additional_field = _.find(this.additionalFields, (field) => item.additional_field_id === field.id);
      });
    },
    autoFill2() {
      this.loading = true;
      const isFirm = this.user.driver_class ? !!this.user.driver_class.is_firm : !!(this.user.firm_no_vat || this.user.firm_vat);
      if (isFirm) {
        this.firma = 1;
      }
      axios
          .get(this.calculateUrl)
          .then(response => {
            this.fillFields(response.data);
          })
          .finally(() => this.loading = false);
    },
    /**
     * Odświeża podgląd obiegów dla AKTUALNIE zaznaczonych sald i dla ręcznie
     * skorygowanej listy pól dodatkowych. Nie rusza zaznaczenia ani listy pól —
     * to admin nimi steruje.
     */
    refreshPreview() {
      if (this.selectedBalances.length === 0) {
        this.obiegi = [];
        this.summary = {total_payment: 0, total_cash: 0, below_minimum: false, zero_payout: false};
        return;
      }

      axios
          .get(this.calculateUrl, {
            params: {
              balances: this.selectedBalances.map((balance) => balance.id).join(','),
              fields: JSON.stringify(this.previewFieldsPayload()),
              confirm_zero_payout: this.confirmZeroPayout ? 1 : 0,
            },
          })
          .then(response => this.fillFields(response.data, {autoSelect: false, syncFields: false}));
    },
    /**
     * Lista pól do podglądu w tym samym kształcie, co inputy formularza (AdditionalFields.vue):
     * typ z wybranej pozycji listy, wpis profilu kierowcy (record_id). Dzięki temu podgląd
     * i zapis przydzielają pola do tych samych obiegów.
     */
    previewFieldsPayload() {
      return (this.paymentAdditionalFields || []).map((field) => ({
        id: field.additional_field?.id ?? null,
        name: field.additional_field?.name ?? field.name ?? '',
        value: field.value,
        user_field_id: field.user_field_id ?? null,
        param1: field.param1 ?? null,
        param2: field.param2 ?? null,
        repeat: field.repeat ?? 1,
      }));
    },
    fillFields(data, options = {}) {
      const autoSelect = options.autoSelect !== false;
      const syncFields = options.syncFields !== false;

      this.obiegi = data.obiegi || [];
      this.summary = data.summary || {total_payment: 0, total_cash: 0, below_minimum: false, zero_payout: false};

      if (this.obiegi.length === 0) {
        if (autoSelect) {
          alert('Brak sald do rozliczenia!');
        }
        return;
      }

      if (autoSelect) {
        const allBalanceIds = _.uniq(_.flatMap(this.obiegi, (o) => o.balance_ids || []));
        _.forEach(allBalanceIds, (id) => {
          const balance = _.find(this.balances, (item) => item.id === +id);
          if (balance && !_.find(this.selectedBalances, (item) => item.id === balance.id)) {
            this.toggleBalance(balance);
          }
        });
      }

      if (this.obiegi.length === 1 && this.obiegi[0].type === 'legacy') {
        this.fillLegacyFields(this.obiegi[0], syncFields);
      } else if (syncFields) {
        // Mix / live-only / kilka firm: kwoty wypłat liczy serwer, ale pola dodatkowe kierowcy
        // muszą być widoczne i usuwalne. Backend rozdziela je między obiegi (legacy-only może
        // zostać w jednym, zwykłe w innym) i wystawia w user_additional_fields — zbieramy ze
        // wszystkich obiegów, bo formularz wysyła pełną listę i serwer rozdziela ją ponownie.
        this.applyAdditionalFields({user_additional_fields: this.allUserFields()});
        this.componentKey += 1;
      }
    },
    allUserFields() {
      return _.flatMap(this.obiegi, (o) => o.user_additional_fields || []);
    },
    applyAdditionalFields(obieg) {
      this.paymentAdditionalFields = [];
      for (let field of ((obieg && obieg.user_additional_fields) || [])) {
        field.additional_field = _.find(this.additionalFields, (item) => field.additional_field_id === item.id);
        this.paymentAdditionalFields.push(field);
      }
    },
    fillLegacyFields(obieg, syncFields = true) {
      const payout = obieg.payout || {};
      const provisions = obieg.provisions || {};
      const calculated = obieg.calculated || {};

      if (syncFields) {
        this.applyAdditionalFields(obieg);
      }
      if (obieg.hasReferral) {
        this.referral_cb = true;
      }
      this.zusIncluded = obieg.zus_included;
      this.wyplata_umowa_serwisowa = payout.wyplata_umowa_serwisowa ?? 0;
      this.wyplata_umowa_wynajmu = payout.wyplata_umowa_wynajmu;
      this.wyplata_umowa_zlecenie = payout.wyplata_umowa_zlecenie;
      this.wyplata_zwrot_kosztow = payout.wyplata_zwrot_kosztow;
      this.vat2 = payout.zwrot_vat;
      this.zwrot_vat = payout.zwrot_vat;
      this.total_payment = obieg.total_payment;
      this.provisionFromBalances = provisions.fromBalances;
      this.taxiProvision = provisions.taxi;
      this.courierProvision = provisions.courier;
      this.taxiB2bAmount = payout.taxiB2bAmount ?? 0;
      this.courierB2bAmount = payout.courierB2bAmount ?? 0;
      this.provision = provisions.provision;
      this.provisionTotal = provisions.total;
      this.kwota_z_wyplat = payout.kwota_z_wyplat;
      this.calculated.cash = calculated.cash;
      this.calculated.brutto = calculated.brutto;
      this.calculated.onlinePayment = calculated.onlinePayment;
      this.calculated.totalVat = calculated.totalVat;
      // Alerty i przemontowanie listy pól tylko przy autouzupełnieniu. Odświeżenie podglądu
      // (syncFields: false) przychodzi w trakcie edycji pól — przemontowanie zabrałoby fokus
      // z pola, w którym admin pisze, a alert przerywałby wpisywanie. Status obiegu widać
      // w podglądzie (badge i baner).
      if (!syncFields) {
        return;
      }
      // canMakePaymentInTotal === "obieg zostanie utworzony", więc status below_minimum
      // go NIE zapala — tam wystarczy baner i badge przy obiegu. Blokujący alert zostaje
      // dla realnych blokad (too_small, too_small_additional). Wypłata 0,00 zł bez
      // potwierdzenia (zero_unconfirmed) też nie alertuje — admin widzi baner i checkbox.
      if (!obieg.canMakePaymentInTotal && obieg.status !== 'zero_unconfirmed') {
        alert('Za mała wypłata!');
      }
      if (!obieg.can_make_payment_with_additional) {
        alert('Za mała wypłata żeby uwzględnić pola tymczasowe!');
      }
      this.componentKey += 1;
    },
    statusBadgeClass(status) {
      if (status === 'created') {
        return 'badge-success';
      }
      // below_minimum: obieg POWSTANIE (admin rozlicza ręcznie poniżej progu) — inny
      // kolor niż statusy blokujące, żeby nie sugerować, że rozliczenie przepadnie.
      // zero_unconfirmed (wypłata 0,00 zł do potwierdzenia) zostaje w badge-warning.
      return status === 'below_minimum' ? 'badge-info' : 'badge-warning';
    },
    toggleBalance(balance) {
      if (!!_.find(this.selectedBalances, (item) => item.id === balance.id)) {
        _.remove(this.selectedBalances, {id: balance.id});
      } else {
        this.selectedBalances.push(balance);
      }
      if (!this.selectedBalances || this.selectedBalances.length === 0) {
        this.vat2 = 0;
        this.wyplata_zwrot_kosztow = 0;
      }
      this.calculatePayment();
      this.debouncedRefresh();
    },
    calculatePayment() {
      this.submitDisabled = this.selectedBalances.length === 0;
      this.provisionFromBalances = 0;
      let total = 0.00;
      let onlinePayment = 0.00;
      let totalVat = 0.00;
      let totalCash = 0.00;

      this.invoices_vat_return = +this.user.invoices_vat_balance;
      this.invoices_cost_return = +this.user.invoices_cost_balance;

      if (+this.firma === 1) {
        this.wyplata_umowa_zlecenie = 0;
        this.wyplata_zwrot_kosztow = 0;
        this.wyplata_umowa_serwisowa = 0;
      }

      for (let balance of this.selectedBalances) {
        this.provisionFromBalances += Math.abs(Math.round(parseFloat(balance.provision) * 100) / 100);
        const partBrutto = parseFloat(balance.total);
        total += partBrutto;
        onlinePayment += parseFloat(balance.online);

        if (balance.imported && balance.imported.length > 0) {
          for (let i = 0; i < balance.imported.length; i++) {
            const vatItem = balance.imported[i];
            totalVat += Math.abs(parseFloat(vatItem.value));
          }
        } else {
          const partVat = parseFloat(balance.vat) / 100;
          totalVat += Math.abs(partBrutto * partVat);
        }
        totalCash += +balance.collected_cash;
      }
      switch (+this.user.provision_type) {
        case 1:
          this.provisionFromBalances = Math.round(total * (+this.user.provision_value / 100) * 100) / 100;
          break;
      }
      this.provisionFromBalances = _.round(this.provisionFromBalances * this.provisionMultiplier, 2);
      totalVat = Math.round(totalVat * 100) / 100;

      this.calculated.brutto = Math.round(total * 100) / 100;
      this.calculated.cash = Math.round(totalCash * 100) / 100;
      this.calculated.onlinePayment = Math.round(onlinePayment * 100) / 100;
      this.calculated.totalVat = totalVat;
      if (this.vat2 > this.calculated.totalVat) {
        this.vat2 = this.calculated.totalVat;
      }

      const prowizja = _.round(+this.provision + this.provisionFromBalances, 2);

      this.provisionTotal = prowizja;
      const koszt_zlecenie_umowa = +this.cost_uz_dochodowy;
      const zwrot_vat = +this.vat2;
      const przelew = parseInt(this.elixir);
      const total_online = onlinePayment;

      const przelew_kwota = (przelew === 0) ? 0.00 : 7.00;


      let additional = 0;
      for (let field of this.paymentAdditionalFields) {
        additional += +field.value;
      }
      this.total_payment = Math.round(100 * Math.max(0, total_online - totalVat - prowizja - koszt_zlecenie_umowa - przelew_kwota + zwrot_vat + additional)) / 100;
      this.kwota_z_wyplat = Math.round(100 * Math.max(0, this.total_payment - this.wyplata_umowa_zlecenie - this.wyplata_zwrot_kosztow - this.wyplata_umowa_serwisowa)) / 100;

      this.wyplata_umowa_wynajmu = this.kwota_z_wyplat;
      this.zwrot_vat = zwrot_vat;

      // Klasy z lease_to_mandate_transfer (np. student): najem trafia w całości na umowę zlecenie.
      // Spójnie z backendem (PaymentService::calculate). Idempotentne — po transferze najem = 0.
      const transferRules = this.user.driver_class?.settlement_rules;
      const leaseToMandate = transferRules ? !!transferRules.lease_to_mandate_transfer : !!this.user.firm_student;
      if (leaseToMandate && +this.firma !== 1) {
        this.wyplata_umowa_zlecenie = +this.wyplata_umowa_zlecenie + +this.wyplata_umowa_wynajmu;
        this.wyplata_umowa_wynajmu = 0;
        this.kwota_z_wyplat = 0;
      }

      if (+this.firma === 1) {
        this.recalculateB2bSplit();
      }
    },

    recalculateB2bSplit() {
      let taxiOnline = 0, taxiVat = 0, taxiBalanceProvision = 0, taxiTotal = 0;
      let courierOnline = 0, courierVat = 0, courierBalanceProvision = 0, courierTotal = 0;

      for (let balance of this.selectedBalances) {
        const type = balance.application?.type;
        const online = parseFloat(balance.online) || 0;
        const balanceTotal = parseFloat(balance.total) || 0;
        let vat = 0;

        if (balance.imported && balance.imported.length > 0) {
          for (let vatItem of balance.imported) {
            vat += Math.abs(parseFloat(vatItem.value) || 0);
          }
        } else {
          const partVat = parseFloat(balance.vat) / 100;
          vat += Math.abs(balanceTotal * partVat);
        }

        const balanceProvision = Math.abs(parseFloat(balance.provision) || 0);

        if (type === 'taxi') {
          taxiOnline += online;
          taxiVat += vat;
          taxiBalanceProvision += balanceProvision;
          taxiTotal += balanceTotal;
        } else if (type === 'courier') {
          courierOnline += online;
          courierVat += vat;
          courierBalanceProvision += balanceProvision;
          courierTotal += balanceTotal;
        }
      }

      const multiplier = this.provisionMultiplier ?? 1;
      let taxiProvFromBalance, courierProvFromBalance;

      if (+this.user.provision_type === 1) {
        taxiProvFromBalance = _.round(taxiTotal * (+this.user.provision_value / 100) * multiplier, 2);
        courierProvFromBalance = _.round(courierTotal * (+this.user.provision_value / 100) * multiplier, 2);
      } else {
        taxiProvFromBalance = _.round(taxiBalanceProvision * multiplier, 2);
        courierProvFromBalance = _.round(courierBalanceProvision * multiplier, 2);
      }

      const isVatFirm = +this.user.firm_vat === 1;
      const taxiNet = Math.max(0, taxiOnline - (isVatFirm ? 0 : taxiVat) - (+this.taxiProvision || 0) - taxiProvFromBalance);
      const courierNet = Math.max(0, courierOnline - (isVatFirm ? 0 : courierVat) - (+this.courierProvision || 0) - courierProvFromBalance);
      const totalNet = taxiNet + courierNet;

      if (totalNet > 0) {
        this.taxiB2bAmount = _.round(this.kwota_z_wyplat * (taxiNet / totalNet), 2);
        this.courierB2bAmount = _.round(this.kwota_z_wyplat - this.taxiB2bAmount, 2);
      } else {
        this.taxiB2bAmount = this.kwota_z_wyplat;
        this.courierB2bAmount = 0;
      }
    },
    referralCbChanged() {
      if (this.loading) {
        return;
      }
      if (this.user.referral_ask > 0) {
        if (this.referral_cb) {
          this.wyplata_zwrot_kosztow += +this.user.referral_ask;
          this.total_payment += +this.user.referral_ask;
        } else {
          this.wyplata_zwrot_kosztow -= +this.user.referral_ask;
          this.total_payment -= +this.user.referral_ask;
        }

      }
    }
  },
  beforeMount() {
    this.init();
  }
}
</script>
